module.exports = __webpack_public_path__ + "img/settings-icon.d697debe.svg";